// organize-imports-ignore
import './init';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import App from 'components/App';
import { environmentVars } from 'constants/services';
import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import { createAppServices } from 'providers/app-services';
import '@bluebeam/react-skyline-button/styles';
import '@bluebeam/react-skyline-dialog/styles';
import { AppInfo } from 'constants/environment';

const history = createBrowserHistory();
createAppServices(history);

export const renderAppFor = (appInfo: AppInfo): void => {
  if (appInfo.nodeEnv === 'production' && environmentVars.SENTRY_DSN) {
    Sentry.init({
      dsn: environmentVars.SENTRY_DSN,
      release: appInfo.release,
      environment: environmentVars.OBSERVABILITY_ENV_NAME,
      integrations: [
        new Sentry.Replay(),
        new Integrations.BrowserTracing({
          tracePropagationTargets: environmentVars.SENTRY_TRACING_ORIGINS,
          routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
        }),
      ],
      // This sets the sample rate to be 0%. You may want this to be 100% while
      // in development and sample at a lower rate in production
      replaysSessionSampleRate: 0,

      // If the entire session is not sampled, use the below sample rate to sample
      // sessions when an error occurs.
      replaysOnErrorSampleRate: 0.2,
      tracesSampleRate: environmentVars.SENTRY_SAMPLE_RATE,
    });

    const ProfiledApp = Sentry.withProfiler(App);
    ReactDOM.render(
      <ProfiledApp history={history} />,
      document.getElementById('root')
    );
  } else {
    ReactDOM.render(<App history={history} />, document.getElementById('root'));
  }
};
